    <div class="container">
          <div class="row login-box">
            <div class="col-5 left-col">
              ONLINE VOTER PORTAL<br><br>
              <span style="font-size: 12px">
              If you don't have a login credentials, kindly contact administrator for details.   
              </span>            
            </div>
            <div class="col-7 right-col">
              <div class="login-content">
                  <div class="login-form">
                     <div class="form-row">
                        <div class="col-md-2 icorow">
                          <img src="../assets/img/logo.jpg" class="logicon">
                        </div>
                        <div class="col-md-10 logotext">
                          <span class="logotitle">ONLINE VOTING SYSTEM</span>
                          <span class="logosubtitle">Secure Voter Login</span>
                        </div>
                      </div>
                      <div class="loginbox">
                          <div class="input-group mb-3">
                            <div class="input-group-prepend">
                              <span class="input-group-text">#</span>
                            </div>
                            <input type="text" class="form-control" [(ngModel)]="phoneNumber" name="phoneNumber" placeholder="10 Digit Mobile Number"    maxlength="10" >
                          </div>
                            <div id="recaptcha-container"></div>
                            <button class="btn btn-primary px-4" (click)="sendLoginCode()">Generate OTP</button>
                            <br>
                            <br>
                            <br>

                            <div class="input-group mb-3" *ngIf="windowRef.confirmationResult">
                              <div class="input-group-prepend">
                                <span class="input-group-text">**</span>
                              </div>
                              <input type="text" name="code" class="form-control" placeholder="Enter OTP" [(ngModel)]="verificationCode">
                              <br>
                              <button  class="btn btn-success px-4" (click)="verifyLoginCode()">Verify</button>
                            </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
